'use client';

import { getENV } from '../../../utils/env';
import { useConsentGatedInit } from '../../hooks';

export const GtmV2 = () => {
    const {
        NEXT_PUBLIC_LOCALE,
        NEXT_PUBLIC_GTM_CA_CONTAINER_ID,
        NEXT_PUBLIC_GTM_CA_PREVIEW,
        NEXT_PUBLIC_GTM_CA_AUTH,
        NEXT_PUBLIC_GTM_US_CONTAINER_ID,
        NEXT_PUBLIC_GTM_US_PREVIEW,
        NEXT_PUBLIC_GTM_US_AUTH,
    } = getENV();

    const config = {
        'en-CA': {
            gtmContainerId: NEXT_PUBLIC_GTM_CA_CONTAINER_ID,
            gtmPreview: NEXT_PUBLIC_GTM_CA_PREVIEW,
            gtmAuth: NEXT_PUBLIC_GTM_CA_AUTH,
        },
        'en-US': {
            gtmContainerId: NEXT_PUBLIC_GTM_US_CONTAINER_ID,
            gtmPreview: NEXT_PUBLIC_GTM_US_PREVIEW,
            gtmAuth: NEXT_PUBLIC_GTM_US_AUTH,
        },
    };

    const { gtmAuth, gtmPreview, gtmContainerId } = config[NEXT_PUBLIC_LOCALE];

    const isEnabled = Boolean(gtmContainerId);

    const params = new URLSearchParams({
        id: gtmContainerId,
        ...(gtmAuth && { gtm_auth: gtmAuth }),
        ...(gtmPreview && { gtm_preview: gtmPreview }),
        gtm_cookies_win: 'x',
    });

    const src = isEnabled ? `https://www.googletagmanager.com/gtm.js?${params.toString()}` : '';

    useConsentGatedInit({
        src,
        consentGroup: 'C0002',
        onBeforeInsert: () => {
            window.dataLayer = window.dataLayer || [];
            if (!window.dataLayer.some(entry => entry.event === 'gtm.js')) {
                window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
            }
        },
        onReady: () => {
            console.log('GTM Loaded at', Date.now());
            window.dataLayer.push({ event: 'loaded-gtm' });
        },
    });

    return null;
};
